(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-categories-menu"]) return;
  try {
    
  var button = document.getElementById('search');
  if (button && button.dataset.searchBound !== 'true') {
    button.dataset.searchBound = 'true';
    // 为按钮添加点击事件监听器
    button.addEventListener('click', function() {
      console.log(button.dataset.slideSpeed)
      if (button.dataset.slideSpeed == "true") {
        console.log("1")
        button.dataset.slideSpeed = false
        var fdajing = document.getElementById('fdajing');
        fdajing.classList.add("hidden-element");
        
        var xx = document.getElementById('xx');
        xx.classList.remove("hidden-element");
        var searchBox = document.getElementById('searchBox');
        searchBox.classList.remove("hidden-element");
        searchBox.classList.add("searchBox");
      }else{
        console.log("2")
        button.dataset.slideSpeed = true
        var fdajing = document.getElementById('fdajing');
        fdajing.classList.remove("hidden-element");
        var xx = document.getElementById('xx');
        xx.classList.add("hidden-element");
        var searchBox = document.getElementById('searchBox');
        searchBox.classList.add("hidden-element");
        searchBox.classList.remove("searchBox");
        var searchTrends = document.getElementById('searchTrends');
        searchTrends.classList.add("hidden-element");
        searchTrends.classList.remove("searchTrends");
      }
    });
    searchBox = document.getElementById('searchBox');
  searchBox.addEventListener('click', function() {
      var searchTrends = document.getElementById('searchTrends');
      searchTrends.classList.remove("hidden-element");
      searchTrends.classList.add("searchTrends");
  });
  var searchTrendingList = [
    {"value":"Black Friday Promotion","url":"/pages/promotion"},
    {"value":"f150 airbags","url":"/search?type=product&options%5Bunavailable_products%5D=last&options%5Bprefix%5D=last&q=f150+airbags"},
    {"value":"Keyless Coupler Lock","url":"/products/retrue-com-products-coupler-ball-lock-rtl001kc"},
    {"value":"air bag suspension","url":"/collections/air-suspension-kit"},
  ];
  for (let index = 0; index < searchTrendingList.length; index++) {
    
    const element = searchTrendingList[index];
    createSearchtrends(element,index)
    
  }
  function createSearchtrends(element,index){
    const container = document.createElement('div');
    if(index>0){
        container.style.marginLeft = '20px';
    }
    container.className = 'container';
    
    // 创建内部容器
    const innerContainer = document.createElement('div');
    innerContainer.className = 'inner-container';
    innerContainer.style.marginLeft = '20px';
    innerContainer.style.marginRight = '20px';
    innerContainer.style.display = 'flex';
    innerContainer.style.justifyContent = 'center';
    innerContainer.style.alignItems = 'center';
    
    // 创建链接元素
    const link = document.createElement('a');
    link.href = element["url"];
    link.className = 'text-link';
    link.textContent = element["value"];
    
    // 创建SVG图标
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 1024 1024');
    svg.setAttribute('version', '1.1');
    svg.className = 'icon';
    svg.setAttribute('width', '16');
    svg.setAttribute('height', '16');
    
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M446.112323 177.545051c137.567677 0.219798 252.612525 104.59798 266.162424 241.493333 13.562828 136.895354-78.778182 261.818182-213.617777 289.008485-134.852525 27.203232-268.386263-52.156768-308.945455-183.608889s25.018182-272.252121 151.738182-325.779394A267.235556 267.235556 0 0 1 446.112323 177.545051m0-62.060607c-182.794343 0-330.989899 148.195556-330.989899 330.989899s148.195556 330.989899 330.989899 330.989899 330.989899-148.195556 330.989899-330.989899-148.195556-330.989899-330.989899-330.989899z m431.321212 793.341415a30.849293 30.849293 0 0 1-21.94101-9.102223l-157.220202-157.220202c-11.752727-12.179394-11.584646-31.534545 0.37495-43.50707 11.972525-11.972525 31.327677-12.140606 43.494141-0.37495l157.220202 157.220202a31.036768 31.036768 0 0 1 6.723232 33.810101 31.004444 31.004444 0 0 1-28.651313 19.174142z m0 0');
    path.setAttribute('p-id', '4051');
    path.setAttribute('fill', '#2c2c2c');
    
    // 组装元素
    svg.appendChild(path);
    innerContainer.appendChild(link);
    innerContainer.appendChild(svg);
    container.appendChild(innerContainer);
    
    // 添加到目标容器
    document.getElementById('search-trending-list').appendChild(container);
    
    link.addEventListener('click', (e) => {
      e.preventDefault();
      window.open(element["url"], '_blank');
    });
   
  }
  let lastScrollTop = 0;
  window.addEventListener('scroll', function() {
      // 检测是否为手机端
      var isMobile = window.innerWidth <= 500;
      
      // 手机端不执行滚动特效
      if (true) {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop){
            // 向下滚动
          button.dataset.slideSpeed = true
          // var fdajing = document.getElementById('fdajing');
          // fdajing.classList.remove("hidden-element");
          // var xx = document.getElementById('xx');
          // xx.classList.add("hidden-element");
          // var searchBox = document.getElementById('searchBox');
          // searchBox.classList.add("hidden-element");
          // searchBox.classList.remove("searchBox");
          // var searchTrends = document.getElementById('searchTrends');
          // searchTrends.classList.add("hidden-element");
          // searchTrends.classList.remove("searchTrends");
          // 隐藏默认搜索框
          var shososuok = document.getElementById('shososuok');
          shososuok.classList.add("hidden-element");
          shososuok.classList.remove("t4s-d-lg-block");
          // shososuok.classList.add("hidden-maxh");
          
          var yingccaidan = document.getElementById('yingccaidan');
          yingccaidan.classList.remove("hidden-element");
          yingccaidan.classList.add("t4s-section-header__bot");
          yingccaidan.classList.add("t4s-d-none");
          yingccaidan.classList.add("t4s-d-lg-block");
          var caidan = document.getElementById('caidan');
          caidan.classList.remove("t4s-d-lg-block");
          caidan.classList.add("hidden-element");
          var userDiv = document.getElementById('userDiv');
          userDiv.classList.remove("mat3");
          var logo = document.getElementById('logo');
          logo.classList.remove("mat3");
          var dingbuDiv = document.getElementById('dingbuDiv');
          dingbuDiv.style.position = 'fixed';
          dingbuDiv.style.top = '0';
          if (!isMobile) {
            var searchSuoso = document.getElementById('search');
            searchSuoso.classList.remove("hidden-element");
            searchSuoso.classList.add("searchSosuo");
          }
        }
        if (window.scrollY === 0) {
          var shososuok = document.getElementById('shososuok');
          shososuok.classList.remove("hidden-element");
          shososuok.classList.add("t4s-d-lg-block");
          var searchSuoso = document.getElementById('search');
          searchSuoso.classList.add("hidden-element");
          searchSuoso.classList.remove("searchSosuo");
          var yingccaidan = document.getElementById('yingccaidan');
          yingccaidan.classList.add("hidden-element");
          yingccaidan.classList.remove("t4s-section-header__bot");
          yingccaidan.classList.remove("t4s-d-none");
          yingccaidan.classList.remove("t4s-d-lg-block");
          var caidan = document.getElementById('caidan');
          caidan.classList.add("t4s-d-lg-block");
          caidan.classList.remove("hidden-element");
          var userDiv = document.getElementById('userDiv');
          userDiv.classList.add("mat3");
          var logo = document.getElementById('logo');
          logo.classList.add("mat3");
          var fdajing = document.getElementById('fdajing');
          fdajing.classList.remove("hidden-element");
          var xx = document.getElementById('xx');
          xx.classList.add("hidden-element");
          var searchBox = document.getElementById('searchBox');
          searchBox.classList.add("hidden-element");
          searchBox.classList.remove("searchBox");
          var searchTrends = document.getElementById('searchTrends');
          searchTrends.classList.add("hidden-element");
          searchTrends.classList.remove("searchTrends");
           var dingbuDiv = document.getElementById('dingbuDiv');
          dingbuDiv.style.position = '';
          dingbuDiv.style.top = '';
        } 
        lastScrollTop = st <= 0 ? 0 : st; // 对于顶部，lastScrollTop不小于0
      }
      
      
  });
  productList = document.getElementById('productList');
  collection1 = document.getElementById('collection1');
  const searchBoxInput = document.getElementById('searchBox_input');
  const searchResults = document.getElementById('t4s-frm-search__results');
  
  if (searchBoxInput && searchResults) {
    // 初始状态隐藏搜索结果
    searchResults.classList.remove('show');
    
    searchBoxInput.addEventListener('input', function() {
      if(this.value.trim() !== '') {
          console.log('用户正在输入内容:', this.value);
          searchResults.classList.add('show');
      } else {
          console.log('文本框被清空');
          searchResults.classList.remove('show');
      }
    });
    
    // 监听焦点事件，确保搜索结果区域在需要时显示
    searchBoxInput.addEventListener('focus', function() {
      if(this.value.trim() !== '') {
        searchResults.classList.add('show');
      }
    });
    
    // 监听失焦事件，延迟隐藏搜索结果
    searchBoxInput.addEventListener('blur', function() {
      setTimeout(function() {
        if(searchBoxInput.value.trim() === '') {
          searchResults.classList.remove('show');
        }
      }, 200);
    });
    
    console.log('搜索功能已初始化');
  } else {
    console.log('搜索元素未找到:', {
      searchBoxInput: !!searchBoxInput,
      searchResults: !!searchResults
    });
  }
  // searchBoxInput.addEventListener('mouseover', function() {
  //   searchBox_input = document.getElementById('searchBox_input');
  //   if(searchBox_input.value.trim() !== '') {
  //       collection1.style.opacity = '1';
  //   } else {
  //       collection1.style.opacity = '0';
  //   }
    
  // });
  }
 
  
  

  } catch(e) { console.error(e); }
})();
})();
